import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import Gender from 'components/ConversationDetails/Gender.jsx';
import LocaleInfo from 'components/ConversationDetails/LocaleInfo.jsx';
import CityStateDetails from 'components/ConversationDetails/CityStateDetails';
import CountryDetails from 'components/ConversationDetails/CountryDetails';
import LocalTime from 'components/ConversationDetails/LocalTime.jsx';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import Notes from './contactDetailsModules/Notes.jsx';
import ConversationTags from './contactDetailsModules/ConversationTags.jsx';
import Integrations from './contactDetailsModules/Integrations.jsx';
import { fromNow } from '../../../utilities/fromNowWrapper.js';
import {
  GECKO_CONSTS,
  GECKO_UTILS,
  GeckoAvatar,
  GeckoBtn,
  GeckoIcon,
  GeckoModalService,
  GeckoToastService,
  Overlay,
  Tooltip,
} from 'ui';
import Dropdown from 'react-bootstrap/Dropdown';
import EditableValue from 'components/EditableValue';
import Collapsable from 'components/Collapsable';
import AgentSelect from 'components/AgentSelect';
import GeckoDates from 'services/gecko-date';
import GeckoDate from 'services/gecko-date';
import './contactDetailsModules/Modules.scss';
import './ContactDetails.scss';
import SystemDetails from './systemDetailsModules/SystemDetails.jsx';
import StatsLogic from 'routes/stats/Logic/StatsLogic';

import Phone from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import { showChatHeads } from '../../../actions/ui';
import DraftDisplay from 'components/DraftDisplay';

import {
  fetchContact,
  fetchContactAttendances,
  fetchContactConversationCount,
  fetchContactIntegrationSyncs,
  fetchContactNotes,
} from '../actions';
import ContactMergeModal from 'components/ContactMergeModal';
import { handleDeleteContact } from '../utils/index';
import { onlyUnarchivedSelectableOptions } from 'utilities/customFieldUtils';
import { CONSTS } from 'constants/index.js';
import GeckoFeatures from 'services/gecko-features';
import Events from './contactDetailsModules/Events';
import GeckoStore from 'services/gecko-store';
import ConversationAnalysis from './contactDetailsModules/ConversationAnalysis.jsx';
import Activities from './contactDetailsModules/Activities.jsx';
import { isSupportOrFeatureToggledOn } from 'utilities/featureToggleHelper.js';

const loadingRing = `${process.env.PUBLIC_URL}/img/loading_ring.svg`;

const _ = require('lodash');

export class ContactDetails extends Component {
  constructor(props) {
    super(props);

    const openModule = ['Contact Details'];
    if (props.conversation.tag_ids.length) {
      openModule.push('Tags');
    }

    fetchContact(props.contactId);

    if (this.props.notes === undefined && !this.props.fetchingNotes) {
      fetchContactNotes(this.props.contactId);
    }

    if (
      this.props.attendances === undefined &&
      !this.props.fetchingAttendances
    ) {
      fetchContactAttendances(this.props.contact.contact_id);
    }

    this.state = {
      editMode: false,
      updatingContact: false,
      full_name: props.full_name,
      first_name: props.first_name || '',
      last_name: props.last_name || '',
      email: props.email || '',
      tel: props.tel || '',
      custom_fields: props.custom_fields || {},
      selectableAgents: props.allAgents.map((a) => a.id),
      values: props.contact,
      contactDropDownOpen: false,
      openModule: openModule,
      canViewEvents: GeckoFeatures.can('engage-contact-events'),
      fetchIntegrationPoll: null,
      showOwnerTooltip: false,
      showAllConversationsTooltip: false,
      showOpenConversationsTooltip: false,
      showLastActiveTooltip: false,
      activities: [],
    };
    this.ownerText = createRef();
    this.allConversationTarget = createRef();
    this.openConversationsTooltip = createRef();
    this.lastActiveTooltip = createRef();
    this.viewContactsConversations = this.viewContactsConversations.bind(this);
    this.viewContactsAllConversations =
      this.viewContactsAllConversations.bind(this);
  }

  async componentDidMount() {
    this.unfocusOwnerSelect();
    if (this.props.contactId) {
      fetchContactConversationCount(this.props.contactId);
    }
    if (this.ownerSelect) {
      this.ownerSelect.wrapper.addEventListener('focusout', () => {
        this.unfocusOwnerSelect();
      });
    }
  }

  clearIntegrationsPoll() {
    if (this.state.fetchIntegrationPoll) {
      clearInterval(this.state.fetchIntegrationPoll);
      this.state.fetchIntegrationPoll = null;
    }
  }

  fetchIntegrations(contactUuid, conversationUuid) {
    if (!contactUuid || !conversationUuid) {
      return;
    }

    if (!this.state.fetchIntegrationPoll) {
      this.clearIntegrationsPoll();
      fetchContactIntegrationSyncs(contactUuid, conversationUuid);
      this.state.fetchIntegrationPoll = setInterval(
        () => fetchContactIntegrationSyncs(contactUuid, conversationUuid),
        10000
      );
    }
  }

  componentWillUnmount() {
    this.clearIntegrationsPoll();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentPropsHasNotes =
      this.props.notes && this.props.notes.length !== 0;
    const nextPropsHasNotes = nextProps.notes && nextProps.notes.length !== 0;
    const isNotesModuleOpen = this.state.openModule.includes('Notes');

    this.setState({ addingAgent: false });
    var all_agent_ids = nextProps.allAgents.map(function (obj) {
      return obj.id;
    });
    const allConvoAgents = nextProps.conversation.agents
      .filter((a) => a != null)
      .map((a) => a.id);
    var selectableAgents = _.difference(all_agent_ids, allConvoAgents);

    this.setState({ selectableAgents: selectableAgents });
    if (nextProps.contact.placeholder && !nextProps.fetchingContact) {
      return fetchContact(nextProps.contactId);
    }
    if (
      this.props.contact.id !== nextProps.contact.id ||
      (this.props.fetchingContact === true &&
        nextProps.fetchingContact === false)
    ) {
      this.setState({
        full_name: nextProps.full_name,
        first_name: nextProps.first_name || '',
        last_name: nextProps.last_name || '',
        email: nextProps.email || '',
        tel: nextProps.tel || '',
        custom_fields: nextProps.custom_fields || {},
        values: nextProps.contact,
      });
      if (nextProps.contact.contact_id) {
        fetchContactAttendances(nextProps.contact.contact_id);
      }

      this.fetchIntegrations(
        nextProps.contact.uuid,
        nextProps.conversation.uuid
      );
    } else if (
      this.props.contact.full_name !== nextProps.contact.full_name ||
      this.props.contact.first_name !== nextProps.contact.first_name ||
      this.props.contact.last_name !== nextProps.contact.last_name ||
      this.props.contact.email !== nextProps.contact.email ||
      this.props.contact.tel !== nextProps.contact.tel ||
      JSON.stringify(this.props.contact.custom_fields) !==
        JSON.stringify(nextProps.contact.custom_fields)
    ) {
      this.setState({ values: nextProps.contact });
    }

    if (this.props.contact.contact_id) {
      fetchContactAttendances(this.props.conversation.contact_id);
    }
  }

  handleChange(key, value) {
    // If this is a top level key and the value is an empty string cast it to null
    if (value === '' || value === undefined) {
      value = null;
    }
    const values = GECKO_UTILS.setNestedValue(this.state.values, key, value);
    delete values.external_ids;

    const fieldId =
      key.indexOf('custom_fields') === 0
        ? Number(key.replace('custom_fields.', ''))
        : this.props.fields.find((field) => field.key === key).id;

    GeckoRequest.post(`/contact/${this.props.contact.id}/update-field`, {
      fieldId,
      value,
    })
      .then(() => {
        new GeckoToastService().success('Contact has been updated');
        this.setState({ values: values });
      })
      .catch(renderError);
  }

  getNiceValues(object) {
    return Object.keys(object).reduce((niceValues, key) => {
      let value = object[key] || '';
      if (value.constructor === {}.constructor) {
        value = this.getNiceValues(value);
      }
      return Object.assign({}, niceValues, { [key]: value });
    }, {});
  }

  renderContactDetails() {
    // Change nulls to empty strings so GeckoField can pick up the changes
    const contactMeta = this.getContactMeta();
    const niceValues = this.getNiceValues(this.state.values);
    this.props.fields
      .filter((f) => f.custom_field)
      .forEach(
        (f) =>
          (niceValues.custom_fields[f.id] =
            niceValues.custom_fields[f.id] || '')
      );
    const fields = this.props.fields
      .map((field) => {
        if (field.type === 'telephone' || field.key === 'tel') {
          return {
            label: field.label,
            key: field.custom_field ? `custom_fields.${field.id}` : field.key,
            type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
            component: <Phone placeholder="Enter phone number" />,
            width: '100%',
            order: field.order,
            _type: field.type,
          };
        }
        if (field.type === 'display') {
          return {
            label: field.label,
            key: field.custom_field ? `custom_fields.${field.id}` : field.key,
            type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
            component: <DraftDisplay editorObject={field.editor_object} />,
            width: '100%',
            order: field.order,
            _type: field.type,
          };
        }
        return {
          label: field.label,
          key: field.custom_field ? `custom_fields.${field.id}` : field.key,
          type: field.type,
          options: field.field_options
            ? onlyUnarchivedSelectableOptions(field.field_options)
            : null,
          width: '100%',
          order: field.order,
          format: 'X',
          enableUTC: true,
          display_format: new GeckoDates().FORMATS.SHORT,
          _type: field.type,
        };
      })
      .sort((x, y) => {
        return x.order - y.order;
      })
      .map((field) => {
        return (
          <EditableValue
            key={field.key}
            field={field}
            values={niceValues}
            icon="far fa-user"
            onChange={this.handleChange.bind(this)}
          />
        );
      });
    const items = fields.concat(contactMeta);
    return (
      <div>
        <div className="component-group ContactDetails__contact-values">
          <Collapsable items={items} cutoff={5} />
        </div>
      </div>
    );
  }

  getContactMeta() {
    const additional = this.props.contact.additional;
    const metaDetails = [];
    if (!additional) {
      return metaDetails;
    }
    if (additional.gender) {
      metaDetails.push(<Gender gender={additional.gender} />);
    }
    if (additional.language || additional.locale) {
      metaDetails.push(
        <LocaleInfo locale={additional.language || additional.locale} />
      );
    }
    if (additional.city || additional.state) {
      metaDetails.push(
        <CityStateDetails city={additional.city} state={additional.state} />
      );
    }
    if (additional.country) {
      metaDetails.push(<CountryDetails country={additional.country} />);
    }
    if (additional.timezoneOffset) {
      metaDetails.push(<LocalTime offset={additional.timezoneOffset} />);
    }
    return metaDetails;
  }

  renderSystemMeta() {
    const metadata = this.props.conversation_metadata;
    const deviceType =
      metadata && metadata['device-type'] ? (
        <SystemDetails
          title="Device Type"
          data={metadata['device-type']}
          icon="far fa-desktop"
        />
      ) : null;
    const browserLanguage =
      metadata && metadata['browser-language'] ? (
        <LocaleInfo locale={metadata['browser-language']} />
      ) : null;
    const geoIP =
      metadata && metadata['geo-ip'] && metadata['geo-ip'].ip ? (
        <SystemDetails
          title="IP Address"
          data={metadata['geo-ip'].ip}
          icon="far fa-wifi"
        />
      ) : null;
    const pageTitle =
      metadata && metadata['hostpage_title'] ? (
        <SystemDetails
          title="Page Title"
          data={metadata['hostpage_title']}
          icon="far fa-file"
        />
      ) : null;
    const url =
      metadata && metadata['url'] ? (
        <SystemDetails title="Url" data={metadata['url']} icon="far fa-font" />
      ) : null;
    const pageVisits =
      metadata && metadata['page-visits'] ? (
        <SystemDetails
          title="Page Visits"
          data={metadata['page-visits']}
          icon="far fa-mouse-pointer"
        />
      ) : null;
    const browserVersion =
      metadata && metadata['browser-version'] ? (
        <SystemDetails
          title="Browser"
          data={metadata['browser-version']}
          icon="far fa-browser"
        />
      ) : null;
    const operatingSystem =
      metadata && metadata['operating-system'] ? (
        <SystemDetails
          title="OS"
          data={metadata['operating-system']}
          icon="far fa-desktop"
        />
      ) : null;
    const country =
      metadata && metadata['geo-ip'] && metadata['geo-ip'].country ? (
        <SystemDetails
          title="Country"
          data={metadata['geo-ip'].country}
          icon="far fa-globe-americas"
        />
      ) : null;
    const state =
      metadata && metadata['geo-ip'] && metadata['geo-ip'].state ? (
        <SystemDetails
          title="State"
          data={metadata['geo-ip'].state}
          icon="far fa-globe-americas"
        />
      ) : null;
    const city =
      metadata && metadata['geo-ip'] && metadata['geo-ip'].city ? (
        <SystemDetails
          title="City"
          data={metadata['geo-ip'].city}
          icon="far fa-home"
        />
      ) : null;
    let timeOnPage = null;
    if (metadata && metadata['time-on-page']) {
      let { unit, value } = StatsLogic.secondsToHumanValue(
        Number(metadata['time-on-page'])
      );
      value = Math.floor(value) || 1;
      if (value === 1) {
        unit = unit.substr(0, unit.length - 1);
      }
      timeOnPage = (
        <SystemDetails
          title="Time On Page"
          data={`${Math.floor(value)} ${unit}`}
          icon="far fa-clock"
        />
      );
    }
    if (
      deviceType ||
      browserLanguage ||
      geoIP ||
      pageTitle ||
      url ||
      pageVisits ||
      timeOnPage
    ) {
      return (
        <div>
          {deviceType}
          {operatingSystem}
          {browserVersion}
          {browserLanguage}
          {country}
          {state}
          {city}
          {geoIP}
          {pageTitle}
          {url}
          {pageVisits}
          {timeOnPage}
        </div>
      );
    }
    return null;
  }

  viewContactsConversations() {
    this.props.showChatHeads();
    GeckoLocation.goTo(`/conversations/${this.props.conversation.id}`, {
      contact: this.props.contact.id,
      filter: CONSTS.FILTER_CONTACT_OPEN,
    });
  }

  viewContactsAllConversations() {
    this.props.showChatHeads();
    GeckoLocation.goTo(`/conversations/${this.props.conversation.id}`, {
      contact: this.props.contact.id,
      filter: CONSTS.FILTER_CONTACT,
    });
  }

  focusOwnerSelect() {
    this.ownerText.style.display = 'none';
    this.ownerSelect.wrapper.style.display = 'block';
    this.ownerSelect.setState({ isOpen: true }, () => {
      this.ownerSelect.focus();
    });
  }

  unfocusOwnerSelect() {
    if (this.ownerSelect && this.ownerSelect.wrapper) {
      this.ownerSelect.wrapper.style.display = 'none';
    }
    if (this.ownerText && this.ownerText.style) {
      this.ownerText.style.display = 'block';
    }
  }

  renderSelector() {
    const changeContactOwner = (newOwner) => {
      GeckoRequest.post('/contact/owner', {
        contact_id: this.props.conversation.user_id,
        owner: newOwner,
      }).then(() => {
        this.unfocusOwnerSelect();
      });
    };

    return (
      <div
        id="conversationAgentsHeader"
        className="conversation-header clearfix"
      >
        <div className="conversation-header-contact-owner">
          <div
            className="clickable"
            onClick={this.focusOwnerSelect.bind(this)}
            ref={(elem) => (this.ownerText = elem)}
            id="assign-owner"
            onMouseEnter={() => this.setState({ showOwnerTooltip: true })}
            onMouseLeave={() => this.setState({ showOwnerTooltip: false })}
          >
            <div className={`create-selector-toggle`}>
              <i
                className={`far ${
                  this.props.owner ? 'fa-user' : 'fa-user-plus'
                }`}
              ></i>
              {this.props.owner
                ? this.props.owner.full_name
                : 'Assign an owner'}
            </div>
          </div>
          <AgentSelect
            value={this.props.contact.owner}
            onChange={changeContactOwner}
            multi={false}
            selectProps={{ ref: (elem) => (this.ownerSelect = elem) }}
          />
        </div>
      </div>
    );
  }

  openAccordion(title) {
    const index = this.state.openModule.indexOf(title);
    const openModule = [].concat(this.state.openModule);
    if (index === -1) {
      openModule.push(title);
    } else {
      openModule.splice(index, 1);
    }
    this.setState({ openModule });
  }

  getEventsFromAttendances(attendances) {
    if (!attendances?.length) {
      return;
    }

    let events = attendances.map((attendance) => {
      return {
        ...attendance.event,
        rsvp_link: attendance.rsvp,
        status: attendance.status_title,
        added_at: attendance.created_at,
      };
    });
    return events.filter(
      (event) => event.parent_id === null || event.parent_id === undefined
    );
  }

  renderOpenAccordion(title) {
    switch (title) {
      case 'Conversation Activity':
        return (
          <Activities
            activities={this.props.activities}
            conversation={this.props.conversation}
            channels={this.props.channels}
          />
        );
      case 'Contact Details':
        return <div>{this.renderContactDetails()}</div>;
      case 'Tags':
        return <ConversationTags conversation={this.props.conversation} />;
      case 'Notes':
        return <Notes contact={this.props.contact} notes={this.props.notes} />;
      case 'Events':
        return (
          <Events
            events={this.getEventsFromAttendances(this.props.attendances)}
          />
        );
      case 'System Details':
        return <div>{this.renderSystemMeta()}</div>;
      case 'Integrations':
        return (
          <Integrations
            contact={this.props.contact}
            newIntegrationSyncs={this.props.integrationSyncs}
          />
        );
      case 'Conversation Analysis':
        return <ConversationAnalysis conversation={this.props.conversation} />;
      default:
        break;
    }
  }

  renderTitle(title) {
    const { notes, conversation } = this.props;

    return (
      <span>
        <span className="module-title">{title}</span>
        {title === 'Notes' && (
          <span className="gecko-label badge badge-info count">
            {notes?.length > 0 ? `${notes?.length}` : ''}
          </span>
        )}
        {title === 'Tags' && (
          <span className="gecko-label badge badge-info count">
            {conversation.tag_ids?.length > 0
              ? `${conversation.tag_ids?.length}`
              : ''}
          </span>
        )}
      </span>
    );
  }

  renderModule(title) {
    const isOpen = this.state.openModule.indexOf(title) !== -1;
    return (
      <div className="contact-details-box-module">
        <div
          className="module-heading"
          onClick={() => this.openAccordion(title)}
        >
          {this.renderTitle(title)}
          <span className="text-right">
            <i
              id={`${title}-accordion-icon`}
              className={`far ${isOpen ? 'fa-angle-up' : 'fa-angle-down'}`}
            ></i>
          </span>
        </div>
        {isOpen && this.renderOpenAccordion(title)}
      </div>
    );
  }

  openMergeModal() {
    new GeckoModalService().open(() => (
      <ContactMergeModal contact_id={this.props.contact.id} />
    ));
  }

  renderOpenConversationCount() {
    const pluralisedConversation =
      this.props.contactConversationCount === 1
        ? 'conversation'
        : 'conversations';
    const openCount =
      this.props.contactConversationCount === undefined ? (
        <GeckoIcon icon="far fa-spinner" />
      ) : (
        String(this.props.contactConversationCount)
      );

    return openCount > 0 ? (
      <div
        className="contact-open-conversations gecko-label badge badge-info"
        id="contact-open-conversations"
        onClick={this.viewContactsConversations}
        ref={this.openConversationsTooltip}
        onMouseEnter={() =>
          this.setState({ showOpenConversationsTooltip: true })
        }
        onMouseLeave={() =>
          this.setState({ showOpenConversationsTooltip: false })
        }
      >
        <Overlay
          target={this.openConversationsTooltip.current}
          show={this.state.showOpenConversationsTooltip}
          placement="bottom"
        >
          {(props) => <Tooltip {...props}>View all open conversations</Tooltip>}
        </Overlay>
        {openCount} open
      </div>
    ) : null;
  }

  render() {
    const isSupport = GeckoStore.redux.get('appState.isSupport');
    return (
      <div className="contact-details__wrapper">
        <div className="contact-details-heading d-flex justify-content-between align-items-center">
          <h3 className="mb-0">Contact details</h3>
          <div className="dropdown-wrapper">
            <Dropdown
              className="ContactDetails-dropdown gecko-dropdown"
              show={this.state.contactDropDownOpen}
              onToggle={(contactDropDownOpen) => {
                this.setState({ contactDropDownOpen });
              }}
            >
              <Dropdown.Toggle
                as="button"
                className="ContactDetails-dropdown-toggle gecko-btn btn btn-outline-primary btn-sm icon-only"
              >
                <i className="far fa-ellipsis-v" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="gecko-dropdown-menu">
                <Dropdown.Item onClick={this.viewContactsAllConversations}>
                  View All Conversations
                </Dropdown.Item>
                <Dropdown.Item onClick={this.openMergeModal.bind(this)}>
                  Merge Contact
                </Dropdown.Item>
                <Dropdown.Item
                  className="gecko-dropdown-item-delete"
                  onClick={() =>
                    handleDeleteContact(this.props.contact.id, null, true)
                  }
                >
                  Delete Contact
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="ContactDetails">
          <div className="contact-details-box-module top">
            <div className="avatar-container">
              <div className="avatar-wrapper d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <GeckoAvatar
                    name={this.props.contact.full_name}
                    first_name={this.props.contact.first_name}
                    last_name={this.props.contact.last_name}
                    color={this.props.contact.additional.avatar_colour}
                    bgImage={
                      this.props.contact.additional
                        ? this.props.contact.additional.profile_picture_url
                        : null
                    }
                  />
                  <div id="contact-name">
                    <div
                      className="contact-details-name"
                      id="contact-details-name"
                    >
                      {this.props.contact.full_name}
                    </div>
                    <div className="chat-head-time">
                      <Overlay
                        target={this.lastActiveTooltip.current}
                        show={this.state.showLastActiveTooltip}
                        placement="bottom"
                      >
                        {(props) => (
                          <Tooltip {...props}>
                            {
                              new GeckoDate(this.props.contact.last_active)
                                .SHORT_TIME
                            }
                          </Tooltip>
                        )}
                      </Overlay>
                      <a
                        id="last-active"
                        ref={this.lastActiveTooltip}
                        onMouseEnter={() =>
                          this.setState({ showLastActiveTooltip: true })
                        }
                        onMouseLeave={() =>
                          this.setState({ showLastActiveTooltip: false })
                        }
                      >
                        {this.props.contact.last_active
                          ? 'active ' + fromNow(this.props.contact.last_active)
                          : ''}
                      </a>
                    </div>
                  </div>
                </div>
                {this.renderOpenConversationCount()}
              </div>
            </div>
            {this.renderSelector()}
          </div>
        </div>
        {this.renderModule('Conversation Activity')}
        {this.renderModule('Contact Details')}
        {/* ====== Modules ====== */}
        {(this.props.conversation.sentiment ||
          this.props.conversation.summary) &&
          isSupportOrFeatureToggledOn('ai-insights') &&
          this.renderModule('Conversation Analysis')}
        {this.renderModule('Tags')}
        {this.renderModule('Notes')}
        {this.state.canViewEvents &&
        this.getEventsFromAttendances(this.props.attendances)?.length
          ? this.renderModule('Events')
          : null}
        {this.props.conversation_metadata && this.renderSystemMeta()
          ? this.renderModule('System Details')
          : null}
        {Object.keys(this.props.contact.external_ids).length ||
        this.props.integrationSyncs?.errors?.length ||
        this.props.integrationSyncs?.syncs?.length
          ? this.renderModule('Integrations')
          : null}
      </div>
    );
  }
}

ContactDetails.defaultProps = {
  contact: {
    additional: {
      profile_picture_url: loadingRing,
    },
    custom_fields: {},
    external_ids: {},
    placeholder: true,
  },
};

ContactDetails.propTypes = {
  id: PropTypes.number,
  gender: PropTypes.string,
  locale: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  full_name: PropTypes.string,
  email: PropTypes.string,
  tel: PropTypes.string,
  avatar_colour: PropTypes.string,
  fake_first_name: PropTypes.string,
  fake_last_name: PropTypes.string,
  avatarLink: PropTypes.string,
  timezoneOffset: PropTypes.number,
  contact: PropTypes.object,
  contactConversationCount: PropTypes.number,
  activities: PropTypes.array,
};

const mapStateToProps = (state, props) => {
  const contact = state.conversationsRoute.contactsById[props.contactId];
  return {
    contact,
    allAgents: state.agents || [],
    allTeams: state.teams || [],
    channels: state.channels,
    owner:
      contact && contact.owner
        ? state.agents.find((agent) => agent.id === contact.owner)
        : null,
    fetchingContact:
      state.conversationsRoute.contactsFetchStatus[props.contactId] &&
      state.conversationsRoute.contactsFetchStatus[props.contactId].fetching,
    account: state.appState.account,
    defaultHeaders: state.appState.defaultHeaders,
    fields: state.fields,
    contactConversationCount: state.conversationsRoute.contactConversations
      ? state.conversationsRoute.contactConversations[props.contactId]
      : undefined,
    notes: state.conversationsRoute.notesByContactId[props.contactId],
    fetchingNotes:
      state.conversationsRoute.notesFetchStatus[props.contactId] &&
      state.conversationsRoute.notesFetchStatus[props.contactId].fetching,
    attendances:
      state.conversationsRoute.attendancesByContactUlid[contact?.contact_id],
    fetchingAttendances:
      state.conversationsRoute.attendanceFetchStatus[contact?.contact_id] &&
      state.conversationsRoute.attendanceFetchStatus[contact?.contact_id]
        .fetching,
    integrationSyncs:
      state.conversationsRoute.integrationSyncByContactId[contact?.uuid],
    fetchingIntegrations:
      state.conversationsRoute.integrationSyncFetchStatus[contact?.uuid]
        ?.fetching,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showChatHeads: () => {
      dispatch(showChatHeads());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetails);
